'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.subscribeComponentFactory = subscribeComponentFactory;

var _immutable = require('immutable');

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = require('redux');

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _amsLoaderUtils = require('@artsman/ams-loader-utils');

var _subscription = require('./subscription');

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ENABLED_KEY = 'enabled';
var DATA_SOURCE_KEY = 'dataSource';
var FILTER_KEY = 'filter';
var GROUP_KEY = 'group';
var ALIAS_KEY = 'alias';
var SORT_KEY = 'sort';
var ONLY_KEY = 'only';
var LIMIT_KEY = 'limit';

var BOOLEAN_KEYS = [ENABLED_KEY];
var STRING_KEYS = [DATA_SOURCE_KEY, FILTER_KEY, GROUP_KEY, ALIAS_KEY];
var LIST_KEYS = [SORT_KEY];
var SET_KEYS = [ONLY_KEY];
var NUMBER_KEYS = [LIMIT_KEY];

var keyStringComparator = function keyStringComparator(targetA, targetB, key) {
  var valueA = targetA[key];
  var valueB = targetB[key];

  if (valueA === undefined && valueB === undefined) {
    return 0;
  } else if (valueA === undefined || valueB === undefined) {
    return 1;
  } else {
    return valueA.localeCompare(valueB);
  }
};

var keyBooleanComparator = function keyBooleanComparator(targetA, targetB, key) {
  return targetA[key] !== targetB[key] ? targetA === true ? 1 : -1 : 0;
};

var keyNumberComparator = function keyNumberComparator(targetA, targetB, key) {
  return targetA[key] !== targetB[key] ? targetA > targetB ? 1 : -1 : 0;
};

var keyListOrSetComparator = function keyListOrSetComparator(targetA, targetB, key, sort) {
  var valueA = targetA[key];
  var valueB = targetB[key];

  if (valueA === undefined && valueB === undefined) {
    return 0;
  } else if (valueA === undefined || valueB === undefined) {
    return 1;
  } else {
    if (Array.isArray(valueA) && Array.isArray(valueB)) {
      if (sort) {
        valueA = valueA.sort();
        valueB = valueB.sort();
      }
      return valueA.length !== valueB.length || valueA.some(function (v, i) {
        return v !== valueB[i];
      }) ? 1 : 0;
    } else {
      if (sort) {
        valueA = valueA.sort();
        valueB = valueB.sort();
      }
      return valueA.size !== valueB.size || valueA.some(function (v, i) {
        return v !== valueB.get(i);
      }) ? 1 : 0;
    }
  }
};

var keyListComparator = function keyListComparator(targetA, targetB, key) {
  return keyListOrSetComparator(targetA, targetB, key, false);
};

var keySetComparator = function keySetComparator(targetA, targetB, key) {
  return keyListOrSetComparator(targetA, targetB, key, true);
};

var keysComparator = function keysComparator(targetA, targetB, keys, keyComparator) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      var result = keyComparator(targetA, targetB, key);
      if (result !== 0) {
        return result;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return 0;
};

// returns 0 if the subscriptions are the same, or returns +1/-1 if they are different
var subscriptionComparator = function subscriptionComparator(subscriptionA, subscriptionB) {
  var result = 0;
  result = result || keysComparator(subscriptionA, subscriptionB, BOOLEAN_KEYS, keyBooleanComparator);
  result = result || keysComparator(subscriptionA, subscriptionB, STRING_KEYS, keyStringComparator);
  result = result || keysComparator(subscriptionA, subscriptionB, NUMBER_KEYS, keyNumberComparator);
  result = result || keysComparator(subscriptionA, subscriptionB, LIST_KEYS, keyListComparator);
  result = result || keysComparator(subscriptionA, subscriptionB, SET_KEYS, keySetComparator);
  return result;
};

/*
 * Higher Order Component (HOC) That subscribes to both a socket and an API reducer for a given set of subscriptions.
 *
 * Subscriptions look like: (NOTE: group, alias, sort, only, limit fields are also now included!)
 *
 *  [
 *    {
 *      dataSource: 'classics',
 *      filter: 'port:520',
 *      channels: [ 'director::api::v1::processes::classics' ]
 *    },
 *    {
 *      dataSource: 'listeners',
 *      filter: 'port:5001',
 *      channels: [ 'director::api::v1::processes::listeners' ]
 *    },
 *    {
 *      dataSource: 'housekeepers',
 *      filter: 'id:1',
 *      channels: [ 'director::api::v1::processes::housekeepers' ]
 *    }
 *  ]
 *
 * A subscription consists of a single endpoint, a single filter, and a list of channels that, when heard on the socket,
  * will trigger a read of that endpoint/filter combination via the API reducer.
 *
 * For a simpler API that uses this Higher Order Component see: /react -> connect( ... )
 *
 */
function subscribeComponentFactory(channels) {
  return function _subscribeComponentFactory(subscriptionsPropKey) {
    var factoryOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _factoryOptions$notif = factoryOptions.notifyCb,
        notifyCb = _factoryOptions$notif === undefined ? undefined : _factoryOptions$notif,
        _factoryOptions$withR = factoryOptions.withRef,
        withRef = _factoryOptions$withR === undefined ? false : _factoryOptions$withR;


    return function _subscribeComponent(WrappedComponent) {

      var displayName = (0, _amsLoaderUtils.getDisplayName)(WrappedComponent);

      var Subscribed = function (_Component) {
        _inherits(Subscribed, _Component);

        function Subscribed(props, context) {
          _classCallCheck(this, Subscribed);

          var _this = _possibleConstructorReturn(this, (Subscribed.__proto__ || Object.getPrototypeOf(Subscribed)).call(this, props, context));

          _this.store = props.store || context.store;
          if (!_this.store) {
            throw "Store is not in the context.  Was the Redux <Provider /> used?";
          }

          _this.unsubscribers = [];
          return _this;
        }

        _createClass(Subscribed, [{
          key: 'getBoundSubscriptions',
          value: function getBoundSubscriptions(props) {
            var dispatchSubscriptions = [];
            var subscriptions = props[subscriptionsPropKey];
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = subscriptions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var subscription = _step2.value;

                //noinspection UnnecessaryLocalVariableJS
                var enabled = subscription.enabled,
                    dataSource = subscription.dataSource,
                    filter = subscription.filter,
                    onSubscribe = subscription.onSubscribe,
                    onAdded = subscription.onAdded,
                    onNotify = subscription.onNotify,
                    onUnsubscribe = subscription.onUnsubscribe;


                var dispatchChannels = void 0;
                if (enabled === undefined || enabled) {
                  dispatchChannels = channels.getIn([dataSource, filter]);
                  if (dispatchChannels === undefined) {
                    dispatchChannels = channels.getIn([dataSource, 'default'], (0, _immutable.List)());
                  }
                } else {
                  dispatchChannels = (0, _immutable.List)();
                }

                dispatchSubscriptions.push(_extends({
                  channels: dispatchChannels,
                  enabled: enabled
                }, (0, _redux.bindActionCreators)({ onSubscribe: onSubscribe, onAdded: onAdded, onNotify: onNotify, onUnsubscribe: onUnsubscribe }, this.store.dispatch)));
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            return (0, _immutable.List)(dispatchSubscriptions);
          }
        }, {
          key: 'subscribeAll',
          value: function subscribeAll(props) {
            return (0, _subscription.subscribe)(this.getBoundSubscriptions(props), {
              notifyCb: notifyCb,
              tag: displayName
            });
          }
        }, {
          key: 'unsubscribeAll',
          value: function unsubscribeAll(unsubscribers) {
            // Unsubscribe from all subscribed data
            unsubscribers.forEach(function (unsubscribe) {
              return unsubscribe();
            });
          }
        }, {
          key: 'componentWillMount',
          value: function componentWillMount() {
            this.unsubscribers = this.subscribeAll(this.props);
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            this.unsubscribeAll(this.unsubscribers);
          }
        }, {
          key: 'areSubscriptionsDifferent',
          value: function areSubscriptionsDifferent(oldSubscriptions, newSubscriptions) {
            var areDifferent = false;
            if (oldSubscriptions !== newSubscriptions) {
              if (oldSubscriptions === undefined || newSubscriptions === undefined || oldSubscriptions.count() !== newSubscriptions.count()) {
                areDifferent = true;
              } else {
                var sortedOldSubscriptions = oldSubscriptions.sort(subscriptionComparator);
                var sortedNewSubscriptions = newSubscriptions.sort(subscriptionComparator);
                var i = void 0,
                    count = sortedOldSubscriptions.count();
                for (i = 0; i < count; i++) {
                  if (subscriptionComparator(sortedOldSubscriptions.get(i), sortedNewSubscriptions.get(i)) !== 0) {
                    areDifferent = true;
                    break;
                  }
                }
              }
            }
            return areDifferent;
          }
        }, {
          key: 'notifyAdded',
          value: function notifyAdded(oldSubscriptions, newSubscriptions) {
            // DEV NOTE: Looks complicated, but just finds all subscriptions that are
            //           in new and not old.
            var added = newSubscriptions.filter(function (n) {
              return !oldSubscriptions.some(function (o) {
                return subscriptionComparator(n, o) !== 0;
              });
            });

            // Lazy-bind the callback to the dispatch and then call it.
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = added[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var sub = _step3.value;
                var onAdded = sub.onAdded;

                if (onAdded !== undefined) {
                  var _bindActionCreators = (0, _redux.bindActionCreators)({ onAdded: onAdded }, this.store.dispatch),
                      boundOnAdded = _bindActionCreators.onAdded;

                  boundOnAdded();
                }
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            var oldSubs = this.props[subscriptionsPropKey];
            var newSubs = nextProps[subscriptionsPropKey];
            if (this.areSubscriptionsDifferent(oldSubs, newSubs)) {
              // Subscribe to all new sources
              var unsubscribers = this.subscribeAll(nextProps);
              // Notify the new subs (in case they have stale data)
              this.notifyAdded(oldSubs, newSubs);
              // Unsubcribe all previous subs
              this.unsubscribeAll(this.unsubscribers);
              this.unsubscribers = unsubscribers;
            }
          }
        }, {
          key: 'setWrappedInstance',
          value: function setWrappedInstance(ref) {
            this.wrappedInstance = ref;
          }
        }, {
          key: 'getWrappedInstance',
          value: function getWrappedInstance() {
            (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } in the options argument of the subscribe() call.');

            return this.wrappedInstance;
          }
        }, {
          key: 'render',
          value: function render() {
            var filteredProps = Object.assign({}, this.props);
            delete filteredProps[subscriptionsPropKey];
            if (withRef) {
              return (0, _react.createElement)(WrappedComponent, _extends({}, filteredProps, { ref: this.setWrappedInstance }));
            } else {
              return (0, _react.createElement)(WrappedComponent, filteredProps);
            }
          }
        }]);

        return Subscribed;
      }(_react.Component);

      Subscribed.displayName = 'Subscribed(' + displayName + ')';
      Subscribed.WrappedComponent = WrappedComponent;

      Subscribed.contextTypes = {
        store: _propTypes2.default.object,
        socket: _propTypes2.default.object
      };
      Subscribed.propTypes = {
        store: _propTypes2.default.object,
        socket: _propTypes2.default.object
      };

      return (0, _hoistNonReactStatics2.default)(Subscribed, WrappedComponent);
    };
  };
}